export const doctorsList = ref([
  { name: 'Jake Weller, RN', code: '1', title: 'ED Nurse', image: 'jake_weller.png' },
  { name: 'Melanie Lam, RN', code: '2', title: 'ED Nurse', image: 'melanie_lam.png' },
  { name: 'Elena Sikora, MD', code: '3', title: 'R1 EM Resident', image: 'elena_sikora.png' },
  { name: 'Javier Flores, MD', code: '4', title: 'R2 EM Resident', image: 'javier_flores.png' },
  { name: 'Tanya Ellis, MD', code: '5', title: 'R4 EM Resident', image: 'tanya_ellis.png' },
  {
    name: 'Gerald Watts, RT',
    code: '6',
    title: 'Respiratory Therapist',
    image: 'gerald_watts.png',
  },
  { name: 'Franklin Nowita', code: '7', title: 'ED Technician', image: 'franklin_nowita.png' },
  { name: 'Jamie Sullivan, RN', code: '8', title: 'ED Charge Nurse', image: 'jamie_sullivan.png' },
]);

export const getDoctorImage = (code: string) => {
  const doctorImage = doctorsList.value.find((doctor) => doctor.code === code)?.image;
  try {
    if (doctorImage) {
      return new URL(`../assets/images/doctors/${doctorImage}`, import.meta.url).href;
    }
  } catch (e) {
    console.warn('Failed to load doctor image:', e);
  }
  return new URL('../assets/images/doctors/tanya_ellis.png', import.meta.url).href;
};

export const getDoctorImageFromName = (name: string) => {
  const doctorImage = doctorsList.value.find((doctor) => doctor.name === name)?.image;
  return new URL(`../assets/images/doctors/${doctorImage}`, import.meta.url).href;
};

export const getDoctorTitle = (name: string) => {
  const doctorTitle = doctorsList.value.find((doctor) => doctor.name === name)?.title;
  return doctorTitle;
};
